export const destinations = {
    title: "Προορισμοί",
    sortName: "Όνομα",
    noResults: "Δεν βρέθηκαν αποτελέσματα",
    tryDifferentSearch: "Δοκιμάστε διαφορετική αναζήτηση"
};
